import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { resolveFunnelUrlByMonetizationTest } from '@/helpers';
import { landingImageResizerConfig } from '@/data/landingConfig/landingImageResizerConfig';
import { MONETIZATION_TEST } from '@/constants';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_ImageResizer } from './schemaObject';

interface Props {}
const ImageResizer: React.FC<Props> = () => {
	const funnelUrl = resolveFunnelUrlByMonetizationTest(
		{
			[MONETIZATION_TEST.NON_TIER_1]:
				GenerateLandingLinkService.funnelImageResizerV2,
		},
		GenerateLandingLinkService.funnelImageResizer,
	);

	return (
		<>
			<AggregateSchema schema={schemaObject_ImageResizer} />
			<LandingTemplate
				data={landingImageResizerConfig}
				funnelLinkService={funnelUrl}
			/>
		</>
	);
};

export default ImageResizer;
